import { frontendURL } from '../../../../helper/URLHelper';
import store from '../../../../store';
import BrandingSettingsView from './pages/BrandingSettingsView.vue';

const redirectIfNotSuperAdmin = (to, _from, next) => {
  const currentUser = store.getters.getCurrentUser;
  if (currentUser?.type === 'SuperAdmin') {
    next();
    return;
  }
  next({ name: 'home', params: { accountId: to.params.accountId } });
};

const brandingSettingsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/branding'),
      name: 'branding_settings_index',
      meta: {
        permissions: ['administrator'],
      },
      beforeEnter: redirectIfNotSuperAdmin,
      component: BrandingSettingsView,
    },
  ],
};

export default brandingSettingsRoutes;
